import { updateItems } from '@/mocks/home';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10 md:mb-14">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
              最新快讯
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              实时追踪娱乐圈最新动态，不错过任何一条重磅爆料
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新中
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-[15px] md:left-[19px] top-0 bottom-0 w-0.5 bg-background-300/60"></div>

          <div className="space-y-0">
            {updateItems.map((item) => (
              <div key={item.id} className="relative pl-10 md:pl-12 pb-7 md:pb-8 last:pb-0">
                <div className="absolute left-0 top-1 w-[30px] md:w-[38px] h-[30px] md:h-[38px] flex items-center justify-center">
                  <div className={`w-2.5 h-2.5 md:w-3 md:h-3 rounded-full border-2 border-background-100 ${
                    item.category === '独家' ? 'bg-primary-500' :
                    item.category === '最新' ? 'bg-accent-500' :
                    'bg-secondary-500'
                  }`}></div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-3">
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className={`px-2 py-0.5 rounded text-xs font-semibold whitespace-nowrap ${
                      item.category === '独家'
                        ? 'bg-primary-100 text-primary-700'
                        : item.category === '最新'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.category}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {item.summary}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}